import { render } from "./SpotHeader.vue?vue&type=template&id=4bdae6a2&scoped=true"
import script from "./SpotHeader.vue?vue&type=script&lang=js"
export * from "./SpotHeader.vue?vue&type=script&lang=js"

import "./SpotHeader.vue?vue&type=style&index=0&id=4bdae6a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bdae6a2"]])

export default __exports__